<template>
  <b-card class="mt-3" header-tag="header">
    <template #header>
      <div>
        <div class="child inline-block-child">
          <img
            v-b-tooltip.hover
            title="General"
            width="20px"
            src="../../../assets/images/memory.svg"
          />
        </div>
        <div class="child inline-block-child">
          <h6 class="mb-0">Memory</h6>
        </div>
      </div>
    </template>
    <div :class="{ hasError: v.$error }">
      <b-form-group
        label="Memory (MiB):"
        label-for="nested-street"
        label-cols-sm="2"
        label-align-sm="right"
      >
        <b-form-input
          id="memory"
          type="number"
          v-model="memory"
          @input="v.$touch()"
        ></b-form-input>

        <label class="placeholderError"> Mínim 1024MiB i màxim 8192MiB </label>
      </b-form-group>
    </div>
  </b-card>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "1024",
    },
    v: {
      type: Object,
      required: true,
    },
  },
  computed: {
    memory: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
<style scoped>
.inline-block-child {
  display: inline-block;
  margin-right: 10px;
}
</style>